// extracted by mini-css-extract-plugin
export const options = "mainMenu-module--options--1GPi4";
export const container = "mainMenu-module--container--3DJM2";
export const sideHelper = "mainMenu-module--sideHelper--1_fKc";
export const card = "mainMenu-module--card--D0QfH";
export const cardImg = "mainMenu-module--cardImg--3rUug";
export const cardInfo = "mainMenu-module--cardInfo--32EYy";
export const divider = "mainMenu-module--divider--xlh_4";
export const buttonContainer = "mainMenu-module--buttonContainer--3xThN";
export const button = "mainMenu-module--button--3dXkS";
export const addButton = "mainMenu-module--addButton--ZA8SJ";
export const removeButton = "mainMenu-module--removeButton--2VRvm";
export const cardSelected = "mainMenu-module--cardSelected--1u5XW";
export const CartAddButton = "mainMenu-module--CartAddButton--2Ls7-";
export const Estimate = "mainMenu-module--Estimate--bQjpN";
export const productList = "mainMenu-module--productList--1FoBn";
export const innerBorder = "mainMenu-module--innerBorder--YBABF";
export const bottomBorder = "mainMenu-module--bottomBorder--2rHNk";
export const topBorder = "mainMenu-module--topBorder--HUHC2";